import { getAdminAxiosInstance } from '../../../api/Admin';

export const getSplashScreen = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/splash-screen/upload-video`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const createSplashScreen = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/splash-screen/store`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteSplashScreen = async (id) => {
  const api = await getAdminAxiosInstance();

  try {
    const response = await api.delete(`/splash-screen/delete?splash_screen_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};